import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Mail, Phone, MessageCircle, Globe, MapPin, Send, Clock, Heart, Truck } from 'lucide-react';
const WHATSAPP_NUMBER = '27732736906';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      alert('Thank you for contacting us! We will get back to you soon.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      setIsSubmitting(false);
    }, 1000);
  };
  const handleWhatsAppContact = () => {
    const message = `Hi! I'd like to get in touch with Bloom & Pop.`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };
  return <div className="min-h-screen bg-white" data-id="element-2029">
      <Navbar data-id="element-2030" />

      <main className="pt-24 pb-16" data-id="element-2031">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-rose-50 to-white py-16" data-id="element-2032">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2033">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-2034">
              <h1 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-2035">
                Get in Touch
              </h1>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-2036">
                We'd love to hear from you! Whether you have a question about
                our products, need a custom order, or just want to say hello.
              </p>
            </motion.div>
          </div>
        </section>

        {/* Contact Information Cards */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-2037">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-2038">
            {/* Email */}
            <motion.a href="mailto:sales@bloomandpop.co.za" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-rose-100 hover:shadow-md transition-all group" data-id="element-2039">
              <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-2040">
                <Mail className="w-6 h-6 text-rose-600" data-id="element-2041" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-2042">Email Us</h3>
              <p className="text-sm text-gray-600 mb-2" data-id="element-2043">
                Send us an email anytime
              </p>
              <p className="text-rose-600 font-medium text-sm" data-id="element-2044">
                sales@bloomandpop.co.za
              </p>
            </motion.a>

            {/* Phone */}
            <motion.a href="tel:0732736906" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-rose-100 hover:shadow-md transition-all group" data-id="element-2045">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-2046">
                <Phone className="w-6 h-6 text-blue-600" data-id="element-2047" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-2048">Call Us</h3>
              <p className="text-sm text-gray-600 mb-2" data-id="element-2049">Mon-Sat, 8AM-6PM</p>
              <p className="text-blue-600 font-medium text-sm" data-id="element-2050">073 273 6906</p>
            </motion.a>

            {/* WhatsApp */}
            <motion.button onClick={handleWhatsAppContact} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-rose-100 hover:shadow-md transition-all group text-left" data-id="element-2051">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-2052">
                <MessageCircle className="w-6 h-6 text-green-600" data-id="element-2053" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-2054">WhatsApp</h3>
              <p className="text-sm text-gray-600 mb-2" data-id="element-2055">
                Quick response guaranteed
              </p>
              <p className="text-green-600 font-medium text-sm" data-id="element-2056">073 273 6906</p>
            </motion.button>

            {/* Website */}
            <motion.a href="https://www.bloomandpop.co.za" target="_blank" rel="noopener noreferrer" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-rose-100 hover:shadow-md transition-all group" data-id="element-2057">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-2058">
                <Globe className="w-6 h-6 text-purple-600" data-id="element-2059" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-2060">Visit Website</h3>
              <p className="text-sm text-gray-600 mb-2" data-id="element-2061">
                Browse our full catalog
              </p>
              <p className="text-purple-600 font-medium text-sm" data-id="element-2062">
                www.bloomandpop.co.za
              </p>
            </motion.a>
          </div>

          {/* Contact Form & Info */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-2063">
            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.5
          }} data-id="element-2064">
              <div className="bg-white rounded-2xl shadow-sm border border-rose-100 p-8" data-id="element-2065">
                <h2 className="font-serif text-2xl font-bold text-gray-900 mb-2" data-id="element-2066">
                  Send us a Message
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-2067">
                  Fill out the form below and we'll get back to you as soon as
                  possible.
                </p>

                <form onSubmit={handleSubmit} className="space-y-4" data-id="element-2068">
                  <Input label="Your Name" type="text" value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} placeholder="John Doe" required data-id="element-2069" />

                  <Input label="Email Address" type="email" value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} placeholder="john@example.com" required data-id="element-2070" />

                  <Input label="Phone Number" type="tel" value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} placeholder="073 123 4567" data-id="element-2071" />

                  <Input label="Subject" type="text" value={formData.subject} onChange={e => setFormData({
                  ...formData,
                  subject: e.target.value
                })} placeholder="How can we help?" required data-id="element-2072" />

                  <div data-id="element-2073">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2074">
                      Message
                    </label>
                    <textarea value={formData.message} onChange={e => setFormData({
                    ...formData,
                    message: e.target.value
                  })} placeholder="Tell us more about your inquiry..." rows={5} required className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-rose-500 focus:border-transparent resize-none" data-id="element-2075" />
                  </div>

                  <Button type="submit" disabled={isSubmitting} className="w-full" size="lg" rightIcon={<Send className="w-5 h-5" data-id="element-2077" />} data-id="element-2076">
                    {isSubmitting ? 'Sending...' : 'Send Message'}
                  </Button>
                </form>
              </div>
            </motion.div>

            {/* Additional Info */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.6
          }} className="space-y-6" data-id="element-2078">
              {/* Business Hours */}
              <div className="bg-gradient-to-br from-rose-50 to-purple-50 rounded-2xl p-8 border border-rose-100" data-id="element-2079">
                <div className="flex items-center gap-3 mb-4" data-id="element-2080">
                  <Clock className="w-6 h-6 text-rose-600" data-id="element-2081" />
                  <h3 className="font-bold text-gray-900 text-xl" data-id="element-2082">
                    Business Hours
                  </h3>
                </div>
                <div className="space-y-2 text-gray-700" data-id="element-2083">
                  <div className="flex justify-between" data-id="element-2084">
                    <span className="font-medium" data-id="element-2085">Monday - Friday:</span>
                    <span data-id="element-2086">8:00 AM - 6:00 PM</span>
                  </div>
                  <div className="flex justify-between" data-id="element-2087">
                    <span className="font-medium" data-id="element-2088">Saturday:</span>
                    <span data-id="element-2089">9:00 AM - 4:00 PM</span>
                  </div>
                  <div className="flex justify-between" data-id="element-2090">
                    <span className="font-medium" data-id="element-2091">Sunday:</span>
                    <span data-id="element-2092">Closed</span>
                  </div>
                </div>
              </div>

              {/* Why Choose Us */}
              <div className="bg-white rounded-2xl p-8 border border-rose-100 shadow-sm" data-id="element-2093">
                <h3 className="font-bold text-gray-900 text-xl mb-4" data-id="element-2094">
                  Why Choose Bloom & Pop?
                </h3>
                <ul className="space-y-3" data-id="element-2095">
                  <li className="flex items-start gap-3" data-id="element-2096">
                    <div className="w-6 h-6 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-2097">
                      <Heart className="w-4 h-4 text-rose-600" data-id="element-2098" />
                    </div>
                    <div data-id="element-2099">
                      <p className="font-medium text-gray-900" data-id="element-2100">
                        100% Personalized
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-2101">
                        Every order is crafted with care
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2102">
                    <div className="w-6 h-6 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-2103">
                      <Truck className="w-4 h-4 text-rose-600" data-id="element-2104" />
                    </div>
                    <div data-id="element-2105">
                      <p className="font-medium text-gray-900" data-id="element-2106">
                        Same Day Delivery
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-2107">
                        Fast and reliable service
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-2108">
                    <div className="w-6 h-6 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-2109">
                      <MessageCircle className="w-4 h-4 text-rose-600" data-id="element-2110" />
                    </div>
                    <div data-id="element-2111">
                      <p className="font-medium text-gray-900" data-id="element-2112">24/7 Support</p>
                      <p className="text-sm text-gray-600" data-id="element-2113">
                        We're here to help anytime
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Quick Contact CTA */}
              <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-2xl p-8 text-white" data-id="element-2114">
                <h3 className="font-bold text-xl mb-2" data-id="element-2115">Need Immediate Help?</h3>
                <p className="text-green-50 mb-4" data-id="element-2116">
                  Chat with us on WhatsApp for instant responses!
                </p>
                <Button onClick={handleWhatsAppContact} className="w-full bg-white text-green-600 hover:bg-green-50" leftIcon={<MessageCircle className="w-5 h-5" data-id="element-2118" />} data-id="element-2117">
                  Open WhatsApp Chat
                </Button>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer data-id="element-2119" />
    </div>;
}